import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PROJECT, TrackingPage, ReturnItemTrackingEvent, TrackingEventName, TrackingEventCategory } from "./tracking";

interface ReturnItemFunction {
  (): void;
}

interface UseTrackReturnItemFunctionArgs {
  readonly page: TrackingPage;
  readonly country: Country;
  readonly segment: Segment;
  readonly checkoutId: string | undefined;
  readonly checkoutItemId: string;
  readonly tradename: Tradename;
}
interface UseTrackReturnItemFunction {
  (agrs: UseTrackReturnItemFunctionArgs): ReturnItemFunction;
}

const useTrackReturnItem: UseTrackReturnItemFunction = ({
  page,
  country,
  segment,
  checkoutId,
  tradename,
  checkoutItemId,
}) => {
  const emitUserEvent = useEmitUserEvent<ReturnItemTrackingEvent>();

  const returnItem: ReturnItemFunction = useCallback(() => {
    if (!checkoutId) {
      return;
    }

    const returnItemTrackingEvent: ReturnItemTrackingEvent = {
      event: TrackingEventName.RETURN_ITEM,
      eventCategory: TrackingEventCategory.NAVIGATION,
      section: `${PROJECT}_${page}`,
      store: country,
      segment,
      checkoutId,
      tradename,
      checkoutItemId,
    };

    emitUserEvent(returnItemTrackingEvent);
  }, [checkoutId, tradename, checkoutItemId, country, emitUserEvent, page, segment]);

  return returnItem;
};

export { useTrackReturnItem };
